export default __webpack_public_path__ + "media/titles/title_6_locale_nl-837f71d3.png";